// 10 типов вейпоинтов, выбираемых вручную в редакторе - подмножество
// backend/app/routes/schemas.py::PoiType (там ещё есть "start"/"finish", см.
// ниже). Подписи берутся из i18n (namespace "poiTypes",
// frontend/src/i18n/locales/*.ts), не отсюда - этот файл только источник
// истины для самих ключей и порядка в UI-пикере.
//
// "start"/"finish" НЕ включены сюда: и на бэкенде (build_route_analytics,
// backend/app/routes/geometry.py - start_entry/finish-маркер), и в отрисовке
// уже опубликованного маршрута (useRouteDrawing.ts::drawRoute) старт/финиш
// определяются исключительно позицией - первая/последняя точка линии, а не
// типом какого-то конкретного вейпоинта. Ручной выбор типа "Старт"/"Финиш" в
// диалоге добавления точки ни на что не влиял бы (только вводил в
// заблуждение), поэтому убран из пикера.
export const POI_TYPES = [
  "night-stop",
  "via-point",
  "water",
  "danger",
  "viewpoint",
  "note",
  "rest-stop",
  "junction",
  "shelter",
  "parking",
] as const;

// В редакторе маршрутов выбираются только эти два типа: ночёвка делит
// маршрут на дни, привал - день на участки (backend/app/routes/geometry.py::
// build_route_analytics). Остальные типы остаются в POI_TYPES - их ещё
// используют админка и уже сохранённые маршруты, но создавать их из редактора
// больше нельзя.
export const EDITOR_POI_TYPES = ["night-stop", "rest-stop"] as const;

export type PoiType = (typeof POI_TYPES)[number];

export function isPoiType(value: string | null | undefined): value is PoiType {
  return !!value && (POI_TYPES as readonly string[]).includes(value);
}
